import * as React from 'react'
import moment from 'moment'
import CustomInput from '../../components/basic/input'
import { CircularProgress, IconButton, InputAdornment } from '@material-ui/core'
import Icon from '@mdi/react'
import { mdiClose } from '@mdi/js'

export const ProductLink = React.memo((props) => {
  const { product, link, saving, removing } = props
  const { inputLabel, updatedTodayLabel, monitoringErrorLabel } = props
  const { handleLinkUpdate, handleDeleteLink } = props
  return (
    <div key={link.id} className={'product-link'}>
      {link.id ? (
      <div className={`product-link-header`}>
        {moment(link.updated_at).format('YYYYMMDD') === moment().format('YYYYMMDD') ? (<span className={'text-green'}>{updatedTodayLabel}</span>) : null}
        {link.error_last_monitoring ? (<span className={'text-danger'}>{monitoringErrorLabel}: {link.error_last_monitoring}</span>) : null}
      </div>
        ) : null}
      <div className={'flex'}>
        <CustomInput
          text={inputLabel}
          value={link.link}
          forceValueUpdatefromProp
          id={`link-index`}
          readOnly={saving || removing}
          className={'w-100'}
          onChange={value => handleLinkUpdate(product.id, link.id, value)}
          customProps={{
            startAdornment: saving ? (
              <InputAdornment position={'start'}>
                <IconButton aria-label={'saving'}>
                  <CircularProgress className={'circular-progress mini'} />
                </IconButton>
              </InputAdornment>
            ) : null,
            endAdornment: (
              <InputAdornment position={'end'}>
                <IconButton
                  aria-label={'delete'}
                  onClick={() => handleDeleteLink(product.id, link.id)}
                >
                  {removing ? (
                    <CircularProgress className={'circular-progress mini'} />
                  ) : (
                    <Icon path={mdiClose} size={1}/>
                  )}

                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </div>
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/screens/ProductShopsManagement/ProductLink.jsx